module.exports = __webpack_public_path__ + "static/media/img19.ffd7fd61.jpg";